<template>
    <v-card class="mt-0 ma-4">
      <v-card-text class="pa-0">
        <base-data-grid
          :ref="grid.key"
          :gridKey="grid.key"
          :dataSource="grid.dataSource"
          :columns="grid.columns"
          @on-add-click="add"
          :exportFileName="title"
          :isStateStoringEnabled="true"
          :allowGrouping="false"
          :allowFilterPanel="false"
          :title="title"
        >
          <template slot="customActionTemplates" slot-scope="row">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="editItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="primary">mdi-pencil</v-icon>
                </a>
              </template>
              <span>{{ $t("Edit") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="deleteItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="red">mdi-delete</v-icon>
                </a>
              </template>
              <span>{{ $t("Delete") }}</span>
            </v-tooltip>
          </template>
        </base-data-grid>
      </v-card-text>
    </v-card>
</template>

<script>
import AccessRightService from '@/services/AccessRightService';
import AccessRightConfig from '@/views/administration/accessRight/AccessRightConfig.vue';
import Utils from '@/ecm/common/Utils';

export default {
    components: {
        AccessRightConfig
    },
    data() {
        return {
            title: this.$t('AccessRights'),
            grid: {
                key: 'accessRightGrid',
                dataSource: AccessRightService.getGrid(),
                columns: [
                    {
                        field: 'Name',
                        caption: this.$t('Name'),
                        type: 'string',
                    },
                ],
            },
            childComponents: []
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.childComponents = [AccessRightConfig.name];
            if (!vm.childComponents.includes(from.name)) {
                vm.gridInstance.saveState(null);
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        this.$nextTick(() => {
            if (this.childComponents.includes(to.name)) {
                const gridState = this.gridInstance.loadState();
                this.gridInstance.saveState(gridState);
            }
            next();
        });
    },
    computed: {
        gridInstance() {
            return this.$refs[this.grid.key];
        },
    },
    methods: {
        editItem(dto) {
            this.$router.push(`/administration/access-rights/${dto.Id}`);
        },
        deleteItem(dto) {
            this.$confirm(this.$t('ItemDeleteConfirmation'), {
                title: this.$t('Delete'),
                icon: 'mdi-alert',
                color: 'red',
                buttonTrueText: this.$t('Delete'),
                buttonFalseText: this.$t('Cancel'),
            }).then((res) => {
                if (res == 1) {
                    AccessRightService.delete(dto.Id).then((result) => {
                        this.gridInstance.refresh();
                        Utils.toast.success(this.$t('AccessRight') + ' ' + this.$t('DeletedSuccessfully'));
                        this.$router.push({ name: 'AccessRightList' });
                    });
                }
            });
        },
        add() {
            this.$router.push('/administration/access-rights/0');
        },
        onItemSaved() {
            this.gridInstance.refresh();
        },
    },
};
</script>